import {Vector2} from "@utility/vector2";
import {Letter} from "@game/map/letter";
import {Region} from "@game/map/region";
import {Place} from "@game/map/place";

export interface ITile {
    altitude: number
    biome: string
    position: Vector2
    region: Region
    regionOffset: Vector2
    tileId: number
    groundImage: string
    placeImage?: string
}

export class Tile {
    private _letter?: Letter;
    private _place?: Place;
    
    constructor(private props: ITile) {
    }

    get altitude() {
        return this.props.altitude;
    }

    get biome() {
        return this.props.biome;
    }

    get groundImage() {
        return this.props.groundImage;
    }

    get placeImage() {
        return this.props.placeImage;
    }

    get letter() {
        return this._letter;
    }

    get location() {
        return {
            regionId: this.props.region.regionId,
            tileId: this.tileId
        }
    }

    get place() {
        return this._place;
    }

    get position() {
        return this.props.position;
    }

    get region() {
        return this.props.region;
    }

    get tileId() {
        return this.props.tileId;
    }

    updateLetter(letter: Letter | undefined) {
        this._letter = letter;
    }

    updatePlace(place: Place | undefined, placeImage: string | undefined = undefined) {
        this._place = place;
        this.props.placeImage = placeImage;
    }

}